import { render, staticRenderFns } from "./EditarEventos.vue?vue&type=template&id=026ffe7c&"
import script from "./EditarEventos.vue?vue&type=script&lang=js&"
export * from "./EditarEventos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports